function newLargeImage(x) {
  let clickedImage = x.dataset.thumbId;
  const newImage = document.querySelector(`[data-media-id="${clickedImage}"]`);
  const parentData = newImage.parentElement;

  parentData.prepend(newImage);
  newImage.style.display = "block";

  document.querySelectorAll('.slide-image').forEach(thumb => thumb.classList.remove('active-thumb'));
  const sliderComp = document.querySelector("slider-component");
  document.querySelector(`[data-thumb-id="${clickedImage}"] > img`).classList.add('active-thumb');
  zoom();
}

window.setTimeout(() => { zoom() });

function zoom() {
  const mediaSmall = window.matchMedia('( min-width: 400px )');
  const imageZoom = document.querySelector('#large-image');
  const zoomItem = document.querySelector("#large-image > li:nth-child(1)")
  imageZoom.addEventListener("mouseout", function () {
    zoomItem.style.transform = 'scale(1)';
  });
  if (mediaSmall.matches) {
    imageZoom.addEventListener("mouseover", function () {
      zoomItem.style.transform = 'scale(1.8)';
    });
    imageZoom.addEventListener("mousemove", function (e) {
      const itemWidth = zoomItem.getBoundingClientRect().width;
      const itemLeft = zoomItem.getBoundingClientRect().left;
      const itemHt = zoomItem.getBoundingClientRect().height;
      const itemTop = zoomItem.getBoundingClientRect().top + window.scrollY;
      const translateX = Math.round((e.pageX - itemLeft) / itemWidth * 100);
      const translateY = Math.round((e.pageY - itemTop) / itemHt * 100);
      zoomItem.style.transformOrigin = `${translateX}% ${translateY}%`;
    });
  }
}